// Helper para convertir URLs relativas de imágenes a absolutas
const ensureAbsoluteImg = (url) => {
  if (!url) return '/assets/logo-safetypoint.png';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return url;
  return '/' + url;
};

export default ensureAbsoluteImg;
